"use client";

import { Drawer, DrawerContent } from "@/shadcn-components/ui/drawer";
import { AgentChatView } from "./AgentChatView";
import { useAgentChat } from "./AgentChatProvider";

interface AgentMobileOverlayProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Mobile agent: bottom drawer at 90% viewport height (underlying tab stays visible). */
export function AgentMobileOverlay({
  open,
  onOpenChange,
}: AgentMobileOverlayProps) {
  const chat = useAgentChat();

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent
        className="mt-0 flex h-[90dvh] max-h-[90dvh] flex-col gap-0 p-0 pb-[env(safe-area-inset-bottom)]"
        aria-label="Vybe Agent"
      >
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <AgentChatView
            variant="mobile"
            speechMode="sendOnStop"
            chat={chat}
            onClose={() => onOpenChange(false)}
          />
        </div>
      </DrawerContent>
    </Drawer>
  );
}
